import { Action, VuexModule, getModule, Module } from 'vuex-module-decorators';
import store from '@/store';
import { applicationFormModule } from './ApplicationForm';
import { accepterUserRegistrationModule } from './AccepterUserRegistration';
import { partialInfoModule } from './PartialInfo';
import { fileUploadModule } from './FileUpload';
import { traderInfoModule } from '../../custom/store/modules/TraderInfo';

@Module({ dynamic: true, store, name: 'uketsukeManagement', namespaced: true })
class UketsukeManagement extends VuexModule {
    /**
     * 申請受付以下のストアモジュールすべてをリセットする
     */
    @Action({})
    public moduleReset() {
        applicationFormModule.moduleReset();
        accepterUserRegistrationModule.moduleReset();
        partialInfoModule.moduleReset();
        fileUploadModule.moduleReset();
        traderInfoModule.moduleReset();
    }
}

export const uketsukeManagementModule = getModule(UketsukeManagement);
